import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface NodeRanking {
  address: string;
  stake: number;
  total_rewards: number;
  total_recent_rewards: number;
  rank: number;
}

export function useNodeRankings() {
  return useQuery({
    queryKey: ["nodeRankings"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('node_rankings')
        .select('*');
      
      if (error) throw error;
      return data as NodeRanking[];
    },
    refetchInterval: 60000, // Refresh every minute
  });
}